module.exports = __webpack_public_path__ + "assets/images/premium-features/business-closed-737012.png";